import _slicedToArray from "C:\\vsts-agent\\_work\\2\\s\\ops-web\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import * as React from "react";
import * as microsoftTeams from "@microsoft/teams-js";
import { notification } from "antd";
var context = React.createContext(fetch);
export function useFetch() {
  return React.useContext(context);
}
var teamsInitialized = new Promise(function (resolve, reject) {
  console.log("init teams...");
  var initialized = false;
  microsoftTeams.initialize(function () {
    initialized = true;
    console.log("init teams done");
    microsoftTeams.appInitialization.notifySuccess();
    microsoftTeams.authentication.getAuthToken({
      successCallback: function successCallback(result) {
        resolve(result);
      },
      failureCallback: function failureCallback(result) {
        notification.error({
          message: "error: " + JSON.stringify(result)
        });
        console.log("error", result);
      }
    });
  });
  setTimeout(function () {
    if (!initialized) {
      reject("timeout");
    }
  }, 1500);
});
teamsInitialized.catch(function (e) {
  console.log("Teams could not be initialized (".concat(e.toString(), ")"));
});
export function TeamsFetchContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      token = _React$useState4[0],
      setToken = _React$useState4[1];

  var f = React.useCallback(function (input, init) {
    if (token !== null) {
      var i = init || {};
      i.headers = Object.assign(Object.assign({}, i.headers), {
        Authorization: "Bearer " + token
      });
      return fetch(input, i);
    } else {
      return fetch(input, init);
    }
  }, [token]);
  React.useEffect(function () {
    teamsInitialized.then(function (v) {
      console.log("teams initialized", v);
      setToken(v);
      notification.success({
        message: "Logged in"
      });
    }).catch(function (e) {
      console.error("Could not initialize teams", e);
    }).finally(function () {
      return setLoading(false);
    });
  }, []);

  if (loading) {
    return null;
  }

  return React.createElement(context.Provider, {
    value: f
  }, children); // children// React.createElement(context.Provider, { value: f }, children);
}